import Icon from '../components/Icon.vue'

Icon.register({"css3":{"width":1792,"height":1792,"paths":[{"d":"M275 128h1505l-266 1333-804 267-698-267 71-356h297l-29 147 422 161 486-161 68-339h-1208l58-297h1209l38-191h-1208z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/css3.js
// module id = 483
// module chunks = 0